import React from "react";
import "./Tools.css";
import img1 from "../assets/img1.png";
import phoneimg from "../assets/phoneImg1.svg";
import img2 from "../assets/img2.png";
import img3 from "../assets/img3.png";
import img4 from "../assets/img4.png";
import img5 from "../assets/img5.png";
import { FiArrowUpRight } from "react-icons/fi";

export default function Tools() {
   const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const toolsData = [
    {
      id: 1,
      logo: img3,
      title: "Custom Digital Profile",
      description:
        "Showcase your properties beautifully with ready-made or personalized templates.",
    },
    {
      id: 2,
      logo: img4,
      title: "NFC Cards With Property Listings",
      description:
        "Share your listed properties and full business details in just one tap.",
    },
    {
      id: 3,
      logo: img5,
      title: "Personalized Business App",
      description:
        "Create a lasting impact on buyers through your own Real Estate Application.",
    },
  ];

  return (
    <div className="tools wrapper">
      <div className="left">
        <div className="images">
          <img src={phoneimg} alt="error" className="img1" />
        </div>
      </div>
      <div className="right">
        <h1>Smart Tools for Brokers, Property Dealers, Agencies, and Owners</h1>
        <div className="main-content">
          {toolsData.map((tool) => (
            <div key={tool.id} className="content">
              <div className="logo">
                <img src={tool.logo} alt={tool.title} />
              </div>
              <div className="text">
                <h3>{tool.title}</h3>
                <p>{tool.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="btn">
          <button onClick={scrollToTop} style={{cursor:"pointer"}}>
            Get 14-Day Free Trial{" "}
            <FiArrowUpRight style={{ marginLeft: "8px" }} />
          </button>
        </div>
      </div>
    </div>
  );
}
